if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // ─── Inject Callout ID under the image ──────────────────────────────────
        const calloutId = opener.getAttribute("data-callout-id");
        if (calloutId) {
          let info = this.querySelector(".product-media-modal__info");
          if (!info) {
            info = document.createElement("div");
            info.className = "product-media-modal__info";
            this.querySelector('[role="document"]').appendChild(info);
          }
          info.textContent = `Callout ID #: ${calloutId}`;
        }
        // ────────────────────────────────────────────────────────────────────────
      }

      showActiveMedia() {
        try {
          // Sanitize and deactivate other media
          const mediaId = this.openedBy.getAttribute("data-media-id") || "";
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${CSS.escape(mediaId)}"])`
          ).forEach((element) => {
            element.classList.remove("is-active");
          });

          // Find the active media
          const activeMedia = this.querySelector(
            `[data-media-id="${CSS.escape(mediaId)}"]`
          );
          if (!activeMedia) {
            console.log("Active media not found for ID:", mediaId);
            return;
          }

          const activeMediaTemplate = activeMedia.querySelector("template");
          const activeMediaContent = activeMediaTemplate
            ? activeMediaTemplate.content
            : null;
          activeMedia.classList.add("is-active");
          activeMedia.scrollIntoView();

          // Handle image loading
          const fullImg = activeMediaContent
            ? activeMediaContent.querySelector("img")
            : activeMedia.querySelector("img");
          const img = activeMedia.querySelector("img");
          if (fullImg && img) {
            if (fullImg.dataset.originalSrc) {
              img.src = fullImg.dataset.originalSrc; // Use full resolution if available
            } else {
              // Fallback to current src or force reload
              img.src = img.src; // Trigger reload to get natural dimensions
            }
            img.onload = () => {
              const container = this.querySelector('[role="document"]');
              if (img.naturalHeight && img.naturalWidth) {
                container.style.height = `${
                  (img.naturalHeight / img.naturalWidth) * 100
                }%`;
              }
              container.scrollLeft =
                (activeMedia.offsetWidth - container.clientWidth) / 2;
            };
          }

          // Handle deferred media (e.g., YouTube)
          if (
            activeMedia.nodeName === "DEFERRED-MEDIA" &&
            activeMediaContent &&
            activeMediaContent.querySelector(".js-youtube")
          ) {
            activeMedia.loadContent();
          }
        } catch (error) {
          console.error("Error in showActiveMedia:", error);
        }
      }
    }
  );
}

const thumbnails = this.querySelectorAll(".thumbnail img");
thumbnails.forEach((thumb) => {
  thumb.style.width = "200px";
  thumb.style.height = "200px";
});
